import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "cookie_consent_v1";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch (e) {
      // ignore
    }
    // Listen for external updates (e.g. GuidedTour auto-accepts to avoid overlap)
    const onUpdate = () => {
      try {
        if (localStorage.getItem(KEY)) setVisible(false);
      } catch (e) {}
    };
    window.addEventListener("cookie-consent-updated", onUpdate);
    return () => window.removeEventListener("cookie-consent-updated", onUpdate);
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ v: 1, at: Date.now() }));
    } catch (e) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Çerez bildirimi"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-md z-[1400] bg-white border border-zinc-200 rounded-sm shadow-2xl p-4"
      data-testid="cookie-banner"
    >
      <div className="flex items-start gap-3">
        <div className="h-9 w-9 grid place-items-center bg-amber-100 text-amber-700 rounded-sm shrink-0">
          <Cookie className="h-4 w-4" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold text-zinc-900 mb-1">
            Çerez Kullanımı
          </div>
          <p className="text-xs text-zinc-600 leading-relaxed">
            Bu uygulama yalnızca oturum güvenliği için gerekli{" "}
            <strong>zorunlu çerezleri</strong> kullanır. Analitik veya pazarlama
            çerezi kullanmıyoruz. Detaylar için{" "}
            <Link
              to="/cerez"
              className="text-zinc-900 underline underline-offset-2 font-medium"
              data-testid="cookie-banner-policy-link"
            >
              Çerez Politikası
            </Link>{" "}
            ve{" "}
            <Link
              to="/gizlilik"
              className="text-zinc-900 underline underline-offset-2 font-medium"
            >
              Gizlilik Politikası
            </Link>
            .
          </p>
          <div className="mt-3 flex items-center gap-2">
            <Button
              type="button"
              onClick={accept}
              className="h-8 rounded-sm bg-zinc-900 hover:bg-zinc-800 text-white text-xs px-3"
              data-testid="cookie-accept-btn"
            >
              Anladım
            </Button>
          </div>
        </div>
        <button
          type="button"
          onClick={accept}
          className="text-zinc-400 hover:text-zinc-900"
          aria-label="Kapat"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
